import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-top",
  "use": "icon-top-usage",
  "viewBox": "0 0 1062 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1062 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-top\"><path d=\"M0 0h1061.012v1024L530.534 777.253 0 1024V0z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/top.svg
// module id = jE4f
// module chunks = 65